// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var contentRouter = {
  path: '/content',
  component: Layout,
  redirect: '/content/building',
  name: 'content',
  meta: {
    title: '内容',
    icon: 'clipboard'
  },
  children: [{
    path: 'articleManager',
    name: 'articleManager',
    component: function component() {
      return import('@/views/content/article/list');
    },
    meta: {
      title: '文章管理',
      icon: 'clipboard'
    }
  }, {
    path: 'articleCreat/:id?',
    name: 'articleCreat',
    component: function component() {
      return import('@/views/content/article/edit');
    },
    meta: {
      title: '添加文章',
      noCache: true,
      activeMenu: "/content/articleManager"
    }
  }, {
    path: 'classifManager',
    name: 'classifManager',
    component: function component() {
      return import('@/views/content/articleclass/list');
    },
    meta: {
      title: '文章分类',
      icon: 'clipboard'
    }
  }, {
    path: 'building',
    component: function component() {
      return import('@/views/content/building/index');
    },
    name: 'StoreBuilding',
    meta: {
      title: '楼栋管理',
      icon: ''
    }
  }, {
    path: 'building/form',
    component: function component() {
      return import('@/views/content/building/form/index');
    },
    name: 'StoreBuildingForm',
    meta: {
      title: '楼栋添加/编辑',
      icon: '',
      noCache: true,
      activeMenu: "/content/building"
    }
  }, {
    path: 'building/floor',
    component: function component() {
      return import('@/views/content/building/floor/index');
    },
    name: 'StoreBuildingFloor',
    meta: {
      title: '楼层管理',
      icon: '',
      noCache: true,
      activeMenu: "/content/building"
    }
  }, {
    path: 'building/floor/form',
    component: function component() {
      return import('@/views/content/building/floor/form/index');
    },
    name: 'StoreBuildingFloorForm',
    meta: {
      title: '楼层添加/编辑',
      icon: '',
      noCache: true,
      activeMenu: "/content/building"
    }
  }, {
    path: 'advertisement',
    component: function component() {
      return import('@/views/content/advertisement/index');
    },
    name: 'AdvertisementList',
    meta: {
      title: '广告管理',
      icon: '',
      noCache: true
    }
  }, {
    path: 'advertisement/form',
    component: function component() {
      return import('@/views/content/advertisement/form/index');
    },
    name: 'AdvertisementForm',
    meta: {
      title: '广告添加/编辑',
      icon: '',
      noCache: true,
      activeMenu: "/content/advertisement"
    }
  }, {
    path: 'tag',
    component: function component() {
      return import('@/views/content/tag/index');
    },
    name: 'TagList',
    meta: {
      title: '标签管理',
      icon: '',
      noCache: true
    }
  }, {
    path: 'tag/form',
    component: function component() {
      return import('@/views/content/tag/form/index');
    },
    name: 'TagForm',
    meta: {
      title: '标签添加/编辑',
      icon: '',
      noCache: true,
      activeMenu: "/content/tag"
    }
  }, {
    path: 'operationLog',
    component: function component() {
      return import('@/views/log/index');
    },
    name: 'operationLog',
    meta: {
      title: '后台日志',
      icon: '',
      noCache: true
    }
  }]
};
export default contentRouter;